enum UserInviteStatus {
  active = 'active',
  consumed = 'consumed',
  expired = 'expired',
  revoked = 'revoked',
}

export default UserInviteStatus
